
import { Fragment, useState, useEffect,useMemo } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {useHistory,Switch} from "react-router-dom";
import '.././App.css';
import { Tab } from '@headlessui/react'
import PaymentOption from '../component/PaymentOption'
import CustomCalendar from '../component/CustomCalendar'
import AddressPicker from '../component/AddressPicker'
import { axios } from '../Network'
import moment from 'moment'
// export default PlaceOrderService; function PlaceOrderService(props) {

    function makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        // this.setState({
        //     generatedID:result
        // })
        return result;
     }
     async function getGrandTotalPriceV2 (items){ 
        // let covertedCart = JSON.parse(items)
        let initialPrice = 0
        // console.log('covertedCart',covertedCart)
        try {
            var getTotalflatRate = 0
            items.map(data => {  initialPrice += data.price * 1  }) 
            let service =  getTotalflatRate 
            return   initialPrice + Number(service) 
        }catch(error) {
            console.log('error',error) 
            return 0
        } 
      }
    async function placeOrderState(cart,cname,mobile){
        try {  
         let id = makeid(10)  
         var totalPrice = await getGrandTotalPriceV2(cart)
          let response = await axios
            .put('/OrderV2',{
               storeOwner:'props.storeID',
               cType:"Order",
               cName:cname,
                cart:cart,
                reference: id,
                resellersID: 'null',
                details: {
                    customerName:cname,
                    contact:'Email',
                    mobile:mobile,
                    Receiver:'SmartDeskPH',
                    ReceiverContactNumber:'SmartDeskPH',
                    // StreetAddress:`${landmark}, ${deliveryRate.displayName}`,
                    orderType:'props.orderType' === 1 ? 'Store-Pickup':'Delivery',
                    selectedDate:'props.userDate',
                    formattedDate:moment().add(4, 'w').format('MMMM DD, YYYY').toString(),
                    // deliveryNotes:notes,
                    // burialMessage:burialNote,
                    // deliveryRateDetails:deliveryRate
                },
                storeDetails:'09363673900',
                storeWebsite:'cart.smartdeskph.com',
                storeCodeName:'Michael',
                payment:'none',
                total:totalPrice,
                code:'props.promocode' === '' ? "NONE" : 'promocode' 
            })
            
            return  response
        } catch(error){
            let id = makeid(10)  
            var totalPrice = await getGrandTotalPriceV2(cart)
             let response = await axios
               .put('/OrderV2',{
                  storeOwner:'props.storeID',
                  cType:"Order",
                  cName:cname,
                   cart:cart,
                   reference: id,
                   resellersID: 'null',
                   details: {
                       customerName:cname,
                       contact:'Email',
                       mobile:mobile,
                       Receiver:'SmartDeskPH',
                       ReceiverContactNumber:'SmartDeskPH',
                       orderType:'props.orderType' === 1 ? 'Store-Pickup':'Delivery',
                       selectedDate:'props.userDate',
                   },
                   storeDetails:'09363673900',
                   storeWebsite:'cart.smartdeskph.com',
                   storeCodeName:'Michael',
                   payment:'none',
                   total:totalPrice,
                   code:'props.promocode' === '' ? "NONE" : 'promocode' 
               })
               
          return  response
            console.log('error',error)
     return null
        }
      }
// }
export {makeid,placeOrderState}


